/**
 * POST /api/v2/pricemulti/adjust — tylko Booking.com (plany zależne vs główny).
 * Nie dotyczy Airbnb.
 * offset: 100 = 0%, 150 = +50%, 50 = -50% (zakres 1–200).
 */
export interface IPriceMultiAdjustBody {
  id_integration: string
  id_calendar: string
  id_room: string
  /** 1–200, patrz percentChangeToOffset */
  offset: string
  /** booking_id planu zależnego (rate) */
  rate: string
}

/** Mapuje price_change_amount (procent względem planu głównego) na offset API. */
export function percentChangeToOffset(amount: number | string | undefined | null): number {
  const n = Math.round(100 + Number(amount ?? 0))
  return Math.max(1, Math.min(200, n))
}

/** price_change_type: '0' | 0 = procent; '1' | 1 = kwota (Booking plan zależny). */
export function isDependentPlanPercentMode(
  integration:
    | { price_change_type?: string | number; price_change_amount?: string | number }
    | undefined,
  depPlan: { price_change_type?: string | number; price_change_amount?: string | number },
): boolean {
  const t =
    integration?.price_change_type !== undefined &&
    integration?.price_change_type !== null
      ? integration.price_change_type
      : depPlan.price_change_type
  return t === '0' || t === 0 || String(t) === '0'
}

export function resolveDependentPriceChangeAmount(
  integration:
    | { price_change_amount?: string | number }
    | undefined,
  depPlan: {
    price_change_amount?: string | number
    price_change?: string | number
  },
): string | number {
  if (
    integration?.price_change_amount !== undefined &&
    integration?.price_change_amount !== null
  ) {
    return integration.price_change_amount
  }
  return depPlan.price_change_amount ?? depPlan.price_change ?? 0
}

export default function(api: GlobalFetch) {
  return async function(body: IPriceMultiAdjustBody) {
    const response = await api.fetch('/api/v2/pricemulti/adjust', {
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    })
    if (response.ok) {
      return response.status.toString()
    }
    const text = await response.text()
    throw new Error(text || response.status.toString())
  }
}
